import React, { useCallback } from 'react';
import { NonMappedGroupContent } from 'features/Reserve/pages/CollectionPage/NonMapped/NonMappedGroupContent';
import useResourceBookingSession from 'features/Reserve/hooks/useResourceBookingSession';
import { buildCanonicalPath, useCanonicalLink } from 'hooks/useCanonicalLink';
import {
  ResourceHeading2,
  ResourceParagraph,
} from 'components/theme/Typography/ResourceTypography';
import { ResponsiveFlex } from 'components/common/styled/common-styled';
import { useGlobalDateLocale } from 'context/DateLocaleContext';
import { formatEventDateLong } from 'utils/dateTime';
import NotFoundExperience from 'components/NotFoundExperience/NotFoundExperience';
import { useHistory } from 'react-router-dom';
import { ResourceGroupPageSkeleton } from '../Skeleton';

export const NonMappedResourceGroupPage = () => {
  const history = useHistory();
  const {
    resourceGroup,
    date,
    groupId,
    collection,
    collectionId,
    isLoadingListing,
  } = useResourceBookingSession();
  const path = buildCanonicalPath({ collectionId, groupId });
  useCanonicalLink(path);
  const { locale } = useGlobalDateLocale();
  const deselectResourceGroup = useCallback(() => {
    history.goBack();
  }, [history]);

  // Show 404 if group ID is in URL but resource group not found after loading
  if (groupId && !isLoadingListing && collection && !resourceGroup) {
    return <NotFoundExperience />;
  }

  if (isLoadingListing || (!collection && !resourceGroup)) {
    return <ResourceGroupPageSkeleton />;
  }

  const Header = !resourceGroup ? null : (
    <ResponsiveFlex direction="column" alignItem="flex-start" gap={12}>
      <ResourceHeading2 className="resource-title">
        {resourceGroup.title}
      </ResourceHeading2>
      <ResourceParagraph
        className="current-date"
        fontSize="16px"
        fontWeight="400"
        lineHeight="20px"
      >
        {date && formatEventDateLong(date, locale)}
      </ResourceParagraph>
    </ResponsiveFlex>
  );

  return (
    <NonMappedGroupContent
      heading={Header}
      size="full"
      open
      onClose={deselectResourceGroup}
    />
  );
};
